/* eslint-disable */
import React, { useState, useReducer, useEffect, useRef } from "react";
import { withRouter } from "react-router";
import {
  message,
  Button,
  Spin,
  Steps,
  Modal,
  Input
} from "antd";
import {
  LoadingOutlined,
  LeftOutlined
} from "@ant-design/icons";
import { connect } from "react-redux";
import moment from 'moment-timezone';
import * as createActions from "../../actions/createTrial.js";
import * as historyActions from "../../actions/historyTrial";
import { initialTrial } from "../../reducers/trialReducer.js";
import TeamMembers from '../../components/NewTrialSteps/TeamMembers';
import SimilarHistoricalTrials from '../../components/NewTrialSteps/SimilarHistoricalTrials';
import TrialSummary from '../../components/NewTrialSteps/TrialSummary';
import { addStudy, updateStudy, getGetReferenceData, getStudy, listMembers, getTrialPresets, saveTrialPresets} from "../../utils/ajax-proxy";
import { isAuthenticated, getEmail } from "../../utils/auth";
import "./index.scss";

const { Step } = Steps;
const { TextArea } = Input;

export const phase_options = [
  "Early Phase 1",
  "Phase 1",
  "Phase 2",
  "Phase 3",
  "Phase 4"
];
export const study_types = [
  "Interventional",
  "Observational",
  "Patient Registries",
  "Expanded Access",
];
export const study_status = [
  "Available",
  "Withdrawn",
  "Withheld",
  "Temporarily not available",
  "Recruiting",
  "Active, not recruiting",
  "Not recruiting",
  "Not yet recruiting",
  "No longer available",
  "Enrolling by invitation",
  "Suspended",
  "Approved for marketing",
  "Unknown status",
  "Completed",
  "Terminated"
]
const timeline = ["Trial summary", "Similar historical trials","Team members"]
const validateFields = ["trial_alias", "trial_title", "therapeutic_area", "indication", "description", "molecule_name", "estimated_enrollment_count", "number_of_arms", "treatment_duration", "treatment_duration_months", "cycle_based_trial_flag", "days_per_cycle"];
const requiredStringFields = ["trial_alias", "trial_title", "therapeutic_area", "estimated_enrollment_count", "number_of_arms", "cycle_based_trial_flag", "days_per_cycle"];
const requiredListFields = ["indication"];
const init = {
  trial_title: "",
  description: "",
  therapeutic_area: [],
  indication: [],
  trial_alias: "",
  study_type: [],
  study_phase: [],
  members: [],
  status: "",
  lastUpdatedDate: "",
  similar_history_count: null,
  molecule_name: "",
  pediatric_study: null,
  study_country: "",
  scenarios: [],
  CostAvg: 0,
  BurdenAvg: 0,
  soa_status_flag: "",
  toggle_indication: true,
  dateFrom: null,
  dateTo: null,
  study_status: null,
  userRolesList: [],   
  primary_endpoints: [],
  secondary_endpoints: [],
  tertiary_endpoints: [],
  similarHistoricalTrials: [], 
  studyPhaseList: [],
  studyTypeList: [],
  studyCountryList:[],
  indicationList: [], 
  studyStatusList: [],
  indicationTherapeuticMapping: {},
  estimated_enrollment_count: 0, 
  number_of_arms: 1, 
  treatment_duration: 1,
  saved_filters: {
    study_phase: [],
    study_type: [],
    indication: [],
    study_status: [],
    study_start_date: [2010, 2025],
    moa: [],
    pediatric: null,
    soa: null,
    toggle: true,
    patient_segment: []
  },

  oncology_flag:false,
  cycle_based_trial_flag:null,
  days_per_cycle:null,
  treatment_duration_months:null
};
const presets_init = {
  preset_name : "",
  description: "",
}

const NewTrial = (props) => {
  const [updateDetail, setUpdateDetail] = useState(false);
  const [drawerloading, setDrawerloading] = useState(false);
  const [createTrialBtn, setCreateTrialBtn] = useState(false);
  const [indicationList, setIndicationList] = useState([]) 
  const [indicationListAll, setIndicationListAll] = useState([])
  const [studyPhaseList, setStudyPhaseList] = useState([])
  const [rolesList, setRolesList] = useState([])
  const [studyTypeList, setStudyTypeList] = useState([])
  const [studyCountryList, setStudyCountryList] = useState([])
  const [studyStatusList, setStudyStatusList] = useState([])
  const [indicationTherapeuticMap, setIndicationTherapeuticMap] = useState([])
  const [therapeuticAreaList, setTherapeuticAreaList] = useState([])
  const [trialAliasError, setTrialAliasError] = useState("");
  const [trialTitleError, setTrialTitleError] = useState("");
  const [therapeuticAreaError, setTherapeuticAreaError] = useState("");
  const [indicationError, setIndicationError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [moleculeNameError, setMoleculeNameError] = useState("");
  const [estimatedTotalError, setEstimatedTotalError] = useState("");
  const [numberOfArmsError, setNumberOfArmsError] = useState("");
  const [lengthOfTreatMentError, setLengthOfTreatmentError] = useState("");
  const [initialState, setInitialState] = useState(init);
  const [step, setStep] = useState(localStorage.getItem('steps')? Number(localStorage.getItem('steps')) : 0);
  const [teamMember, setTeamMember] = useState([]);
  const [editDetailTitle, setEditDetailTitle] = useState("");
  const [newTrial, setNewTrial] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    { ...init }
  );
  const [selectedMoaData, setSelectedMoaData] = useState([])
  const [patientSegmentData, setSelectedPatientSegmentData] =  useState([])
  const [moaList, setMoaList] = useState([])
  const [patientSegmentList, setPatientSegmentList] = useState([])
  const [soaCount, setSoaCount] = useState(0)
  const [soaModal, showSOAModal] = useState(false)
  const [navigateToTeamsPage, setNavigateToTeamsPage] = useState(false)
  const [resetTrialsCount, setResetTrialsCount] = useState(false)
  const pollingIntervalMS = 10000; // Poll every 10 seconds
  const [isSaveTrial, setIsSaveTrial] = useState(false)
  const [showPresetPopup, setShowPresetPopup] = useState(false)
  const [presetsData, setPresetData] = useState(presets_init)
  const [presetErrorMsg, setPresetErrorMsg] = useState(null)
  const [isFilterTab, setIsFilterTab] = useState(true)
  const [isSavePreset, setIsSavePreset] = useState(false)
  const [selectPresetOnSave, setSelectPresetOnSave] = useState(false)
  const [estimatedDuration, setEstimatedDurationError] = useState('')
  const [cycleBasesTrial, setCycleBasesTrialError] = useState('')
  const [daysPerCycle, setDaysPerCycleError] = useState('')

  const resetTrialHandler = () => {
  setResetTrialsCount(true)
  }

  useEffect(() => {
    const checkAuthenticated = async () => {
      if (!(await isAuthenticated(true))) {
        props.history.push("/");
        localStorage.setItem('activeTabKey', JSON.stringify('0'));
        localStorage.setItem('steps', '0')
    }}
    let fetchIndication
    if (props.newTrial.indicationList.length === 0) { 
      fetchIndication = async() => {
        const resp = await getGetReferenceData();
       
        setIndicationList(sortIndication(resp.indication_list))
        props.createTrial({
          indicationList:resp.indication_list
        })
        setIndicationListAll(resp.indication_list)
        let indicationTherapeuticMap = resp.indication_therapeutic_mapping
        setIndicationTherapeuticMap(resp.indication_therapeutic_mapping)
        props.createTrial({
          indicationTherapeuticMapping: indicationTherapeuticMap
        })
        let therapeuticArea = Object.keys(indicationTherapeuticMap)
        setTherapeuticAreaList(therapeuticArea.sort())
        let studyPhaseListWithAll = resp.study_phase_list.map((o) => {
          return o.label
        })
        studyPhaseListWithAll.unshift("All")         
        setStudyPhaseList(resp.study_phase_list)
        setStudyTypeList(resp.study_type_list)
        setStudyCountryList(resp.country_list)
        setStudyStatusList(resp.study_status_list)
        setRolesList(resp.user_roles_list)
        props.createTrial({
          studyPhaseList:resp.study_phase_list
        })
        props.createTrial({
          userRolesList:resp.user_roles_list
        })
        props.createTrial({
          studyTypeList:resp.study_type_list
        })
        props.createTrial({
          studyCountryList:resp.country_list
        })
        props.createTrial({
          studyStatusList:resp.study_status_list
        })
         // fetch team member list
        const respMember = await listMembers("")
        if (resp) {
          let memberList = Object.values(respMember)?Object.values(respMember).map((item,index)=>{
            return item
          }):[]
          setTeamMember(memberList)
        }
      }
    } else {      
      fetchIndication = () => {
        setIndicationList(sortIndication(props.newTrial.indicationList))
        setIndicationListAll(props.newTrial.indicationList)
        let indicationTherapeuticMap = props.newTrial.indicationTherapeuticMapping
        setIndicationTherapeuticMap(props.newTrial.indicationTherapeuticMapping)
        let therapeuticArea = Object.keys(indicationTherapeuticMap)
        setTherapeuticAreaList(therapeuticArea.sort())
        let studyPhaseListWithAll = props.newTrial.studyPhaseList && props.newTrial.studyPhaseList.map((o) => {
          return o.label
        })
        studyPhaseListWithAll.unshift("All")        
        setStudyPhaseList(props.newTrial.studyPhaseList)
        setStudyTypeList(props.newTrial.studyTypeList)
        setStudyCountryList(props.newTrial.studyCountryList)
        setStudyStatusList(props.newTrial.studyStatusList)
        setRolesList(props.newTrial.userRolesList)
      }
    }
    fetchIndication();
    createInitialState();
    checkAuthenticated();
  }, [props.location.state])

  const sortIndication = (indicationList) => {
    if (indicationList.length === 0){
      return indicationList
    } else {
      return indicationList.sort((ind1, ind2) => (ind1.label < ind2.label) ? -1 : (ind1.label > ind2.label) ? 1 : 0);
    }
  }

  const getTitleCase = (val) => {
    let array = val.split("_")
    let firstVal = array[0].charAt(0).toUpperCase() + array[0].slice(1);
    if(array.length < 2){ return firstVal }
    let lastVal = array[1].charAt(0).toUpperCase() + array[1].slice(1);
    return firstVal + " " + lastVal;
  };

  const getLoggedInMember = () => {
    return [{
      name: getEmail(),
      id: getEmail(),
      idx: 1,
      role: "Edit",
      user_role_id: 1,
    }]
  }

  const createInitialState = () => {
    init.members = getLoggedInMember();
    setInitialState(init);
    props.createTrial(JSON.parse(localStorage.getItem('newTrial')))
    if(Object.keys(JSON.parse(localStorage.getItem('newTrial'))).length !== 0) {
      setNewTrial(JSON.parse(localStorage.getItem('newTrial')))
    } else {
      setNewTrial(init);
      localStorage.setItem('newTrial', JSON.stringify(init))
    }
  }

  const handleValidation = (key, v) => { 
    let newTrialData
    if(Object.keys(JSON.parse(localStorage.getItem('newTrial'))).length !== 0){
      newTrialData = JSON.parse(localStorage.getItem('newTrial'))      
    } else {
      newTrialData = newTrial
    }
    let errorMsg = ""; 
    if(requiredStringFields.includes(key) && newTrialData[key]?.length <= 0){
        errorMsg = getTitleCase(key) + " is required."
    }else if(requiredListFields.includes(key) && newTrialData[key].length < 1){
        errorMsg = getTitleCase(key) + " is required."
    }else if(key == "trial_alias" && !newTrialData[key].match(/^[0-9a-zA-Z]+$/)){
        // errorMsg = getTitleCase(key) + " must be alphanumeric characters only."
    }else if (key == "trial_title" && typeof newTrialData[key] === 'string' && newTrialData[key].trim().length > 300) {
        errorMsg = getTitleCase(key) + " must not exceed 300 characters."
    }else if (key == "description" && typeof newTrialData[key] === 'string' && newTrialData[key].trim().length > 500) {
        errorMsg = getTitleCase(key) + " must not exceed 500 characters."
    }else if (key == "trial_alias" && typeof newTrialData[key] === 'string' && newTrialData[key].trim().length !== 6) {
        // errorMsg = getTitleCase(key) + " must be 6 characters."
    }else if (key == "molecule_name" && typeof newTrialData[key] === 'string' && newTrialData[key].trim().length > 80) {
        errorMsg = getTitleCase(key) + " must not exceed 80 characters."
    }else if (key == "therapeutic_area" && newTrialData['therapeutic_area'].length <1) {
      errorMsg = "Therapeutic Area is required."
    } else if (key == "estimated_enrollment_count" &&  newTrialData['estimated_enrollment_count'] > 100000) {
      errorMsg = getTitleCase(key).split(' ')[1] + " must not exceed 100000."
    } else if (key == "estimated_enrollment_count" && newTrialData['estimated_enrollment_count'] < 0 ) {
      errorMsg = getTitleCase(key).split(' ')[1] + " must not be less than 0."
    } else if (key == "estimated_enrollment_count" && !/^[0-9]+$/.test(newTrialData['estimated_enrollment_count'] )) {
       errorMsg = "Estimated enrollment must be greater than 0"
    } else if (key == "number_of_arms" &&  newTrialData['number_of_arms'] > 100) {
      errorMsg = "Number of Arms must not exceed 100."
    } else if (key == "number_of_arms"){
      const armsValue = newTrialData['number_of_arms'];
      const numericArms = Number(armsValue);
        if(numericArms < 1 || armsValue === null || armsValue === undefined) {
          errorMsg = "Number of Arms must not be less than 1."
        } 
    } else if (newTrialData['oncology_flag'] === false && key === "treatment_duration") {  
      const duration = newTrialData['treatment_duration'];        
      if (duration === null || duration === undefined || Number(duration) < 1) {  
        errorMsg = "Length of Treatment Period must not be less than 1";  
      } else {  
        const numericDuration = Number(duration);  
        if (isNaN(numericDuration) || !Number.isInteger(numericDuration)) {  
          errorMsg = "Length of Treatment Period is required and must be a positive number.";  
        } else if (numericDuration > 1000) {  
          errorMsg = "Length of Treatment Period must not exceed 1000.";  
        } 
      }  
    } else if (newTrialData['oncology_flag'] == true && key == "treatment_duration_months" &&  newTrialData['treatment_duration_months'] > 120) {
      errorMsg = "Expected time on treatment must not exceed 120."
    } else if (newTrialData['treatment_duration_months'] !== null && newTrialData['oncology_flag'] == true && key == "treatment_duration_months" && newTrialData['treatment_duration_months'] < 0.25 ) {
      errorMsg = "Expected time on treatment must not be less than 0.25."
    } else if (newTrialData['oncology_flag'] == true && key == "treatment_duration_months" && /^[A-Za-z]+$/.test(newTrialData['treatment_duration_months']?.toString())) {
      // errorMsg = "Expected time on treatment must be greater than 0"
      errorMsg = "Expected time on treatment must not be less than 0.25."
    } 
    else if (key == "cycle_based_trial_flag" && newTrialData['cycle_based_trial_flag'] == null && newTrialData['oncology_flag'] == true) {
      errorMsg = 'Cycle Based Trials is required.'
    } else if (newTrialData['oncology_flag'] == true && key == "days_per_cycle" &&  newTrialData['cycle_based_trial_flag'] == true && newTrialData['days_per_cycle'] > 365) {
      errorMsg = "Cycle length must not exceed 365."
    }else if (newTrialData['days_per_cycle'] !== null && newTrialData['oncology_flag'] == true && key == "days_per_cycle" && newTrialData['cycle_based_trial_flag'] == true && newTrialData['days_per_cycle'] < 1 ) {
      errorMsg = "Cycle length must be greater than 0."
    } else if (newTrialData['oncology_flag'] == true && key == "days_per_cycle" && newTrialData['cycle_based_trial_flag'] == true && /^[a-zA-Z]+$/.test(newTrialData['days_per_cycle']?.toString() )) {
      errorMsg =  "Cycle length must be greater than 0"
    } 
    if(key == "trial_alias"){setTrialAliasError(errorMsg)}
    else if(key == "trial_title"){setTrialTitleError(errorMsg)}
    else if(key == "therapeutic_area"){setTherapeuticAreaError(errorMsg)}
    else if(key == "indication"){setIndicationError(errorMsg)}
    else if(key == "description"){setDescriptionError(errorMsg)}
    else if(key == "molecule_name"){setMoleculeNameError(errorMsg)}
    else if(key == "estimated_enrollment_count"){setEstimatedTotalError(errorMsg)}
    else if(key == "number_of_arms"){setNumberOfArmsError(errorMsg)}
    else if(key == "treatment_duration"){setLengthOfTreatmentError(errorMsg)}
    else if(key == "treatment_duration_months"){setEstimatedDurationError(errorMsg)}
    else if(key == "cycle_based_trial_flag"){setCycleBasesTrialError(errorMsg)}
    else if(key == "days_per_cycle"){setDaysPerCycleError(errorMsg)}

    
    return errorMsg == ""
  };

  const doValidation = () => { 
    let reqFieldsEntered = true
    if (step == 0 || step == 1) {
      for(let key of validateFields){
        if(!handleValidation(key, null)){
            reqFieldsEntered = false
        }
      }
    } 

    if(step == 1 && soaCount < 10 && !navigateToTeamsPage ) { 
      if(isSaveTrial && updateDetail) {
        reqFieldsEntered = true 
        showSOAModal(false)
      } else {
        reqFieldsEntered = false
        showSOAModal(true)
      } 
    }
    return reqFieldsEntered;
  };

  useEffect(() => {
    if(isSaveTrial && updateDetail) {
      handleDetailUpdate();
    }
  }, [isSaveTrial])


  const handleNextStep = async () => { 
    if(doValidation()){ 
      setStep(step + 1)
      localStorage.setItem('steps', (step + 1).toString())
      props.createTrial(newTrial)
    }
  }

  const handleChange = () => {
    showSOAModal(false)
    setNavigateToTeamsPage(false)
  }

  const handleContinue = () => { 
    if(updateDetail) {
      showSOAModal(false)
      setIsSaveTrial(true) 
      return;
    }
    showSOAModal(false)
    setNavigateToTeamsPage(true) 
  }

  useEffect(() => {
    if(!navigateToTeamsPage) return;
    handleNextStep()
  }, [navigateToTeamsPage])

  useEffect(() => {
    props.location.state&&props.location.state.title&&HandleTrialDetailUpdate(props.location.state.title, props.location.state.data)
  }, [props.location.state])

  const sleep = (time: number) => {
    return new Promise((resolve) => setTimeout(resolve, time));
  };
  const resetTrial = () => {
    let n_trial = initialTrial
      n_trial.members = getLoggedInMember();
      localStorage.setItem('newTrial', JSON.stringify(n_trial))  
      props.createTrial(n_trial) 
      createInitialState();
  }
  const handleOk = async () => {
    setDrawerloading(true)
    setCreateTrialBtn(true)
    localStorage.setItem('show-details', 'true')
    let tempTrial = {...props.newTrial}
    tempTrial['status'] = 'Creating'
    tempTrial['lastUpdatedDate'] = moment().utc().format('YYYY-MM-DD HH:mm:ss')
    tempTrial['similar_history_count'] = {total: props.newTrial.similarHistoricalTrials.length, SOA: soaCount}
    props.createTrial(tempTrial)
    localStorage.setItem('newTrial', JSON.stringify(tempTrial))
    const create_trial = JSON.parse(JSON.stringify(props.newTrial))
    delete create_trial.saved_filters
    const resp = await addStudy(create_trial, props.newTrial.saved_filters);
    // detect if trial data preparation is ready: 1. criteria lib with frequency and average; 2. mean cost 
    if (resp&&resp.trial_uuid) {
      const trialId = resp.trial_uuid;
      let dataPreparationRes = false
      let retryTimes = 0
      setDrawerloading(false)
      props.history.push({pathname: '/trials', state: {trial_id: trialId}})      
      message.success('Your trial has been submitted for processing. Please check later.')
      setResetTrialsCount(false);
      setNavigateToTeamsPage(true)
      setSoaCount(0);
      setNewTrial(props.newTrial);            
      setStep(0)
      localStorage.setItem('steps', '0')
      props.fetchHistory({
        shouldFetch: true,
        historyData:[]
      })
      resetTrial()
	  let showDetail = true;
      let isDiffTrial = false;
      do {
        if (!(await isAuthenticated(true))){
          setCreateTrialBtn(false);
          return;
        } 
        let currentTrialId = localStorage.getItem('trial-id')
        isDiffTrial = currentTrialId != '' && trialId != currentTrialId;
        let created_trial = await getStudy(trialId, null, getEmail())
        let study_json = created_trial
        dataPreparationRes = study_json["status"] == "In Progress" || study_json["status"] == "Completed";
        retryTimes += 1
        if (dataPreparationRes && !isDiffTrial){
          message.success("Created Successfully");
          localStorage.setItem('trial-id', trialId)
          localStorage.setItem('trial-detail', JSON.stringify(resp))
          props.fetchHistory({
            shouldFetch: true,
            historyData:[]
          })
        }
        await sleep(pollingIntervalMS);
        showDetail = localStorage.getItem('show-details')?localStorage.getItem('show-details').toUpperCase() == 'TRUE':false
       } while (showDetail && !isDiffTrial && !dataPreparationRes && retryTimes <= 20);
      if (!dataPreparationRes && retryTimes > 20){
        message.error('Trial creation failed - please contact your system administrator.')
        setCreateTrialBtn(false);
      }
    } else {
      message.error('Trial creation failed - please contact your system administrator.')
      setCreateTrialBtn(false);
    }
  };

  const handleDetailUpdate = async () => {
    if(doValidation()){ 
      localStorage.setItem('trial-id', '')
      localStorage.setItem('trial-detail', '')
      let tempTrial = {...props.newTrial}
      tempTrial['status'] = 'Updating'
      tempTrial['lastUpdatedDate'] = moment().utc().format('YYYY-MM-DD HH:mm:ss')
      tempTrial['similar_history_count'] = {total: props.newTrial.similarHistoricalTrials?.length, SOA: soaCount}
      props.createTrial(tempTrial)
      const {trial_uuid, trial_title, trial_alias, description, therapeutic_area,indication,study_phase,study_type,molecule_name, pediatric_study
        ,members, similarHistoricalTrials, primary_endpoints, secondary_endpoints, tertiary_endpoints, estimated_enrollment_count, number_of_arms, treatment_duration, saved_filters, treatment_duration_months, cycle_based_trial_flag, oncology_flag, days_per_cycle } = props.newTrial
      let payload: any = {
        trial_uuid:  trial_uuid,
	      user_name: getEmail()
      }
      switch (editDetailTitle) {
        case "Edit Details":
          payload.trial_title = trial_title;
          payload.trial_alias = trial_alias;
          payload.description = description;
          payload.therapeutic_area = therapeutic_area;
          payload.indication = indication
          payload.study_phase = study_phase;
          payload.study_type = study_type;
          payload.molecule_name = molecule_name;
          payload.pediatric_study = pediatric_study;
          payload.estimated_enrollment_count = estimated_enrollment_count; 
          payload.number_of_arms = number_of_arms; 
          payload.treatment_duration = treatment_duration; 
          payload.treatment_duration_months = treatment_duration_months;
          payload.cycle_based_trial_flag = cycle_based_trial_flag;
          payload.oncology_flag = oncology_flag;
          payload.days_per_cycle = days_per_cycle
          break;
        case "Edit Similar Historical Trial":
          payload.similarHistoricalTrials = similarHistoricalTrials;
          payload.saved_filters = saved_filters;
          break;
        case "Edit Team Members":
            payload.members = members;
          break;
      }
      // Do not send the trial_alias in the payload of update_trial for non-admin users
      localStorage.getItem('user_type')?.toUpperCase() !== 'ADMIN' && delete payload.trial_alias   
      const resp = await updateStudy(payload);
      setUpdateDetail(false)
      props.history.push("/trials");
      setResetTrialsCount(false)
      if (resp) {
        const trialId = resp.trial_uuid;
        let dataPreparationRes = false
        let retryTimes = 0
        message.success('Your changes have been submitted for processing. Please check later.')      
        setStep(0)
        localStorage.setItem('steps', '0')
        props.fetchHistory({
          shouldFetch: true,
          historyData:[]
        })
        let showDetail = true;
        let isDiffTrial = false;
        do {       
          if (!(await isAuthenticated(true))) return;
          let currentTrialId = localStorage.getItem('trial-id')
          isDiffTrial = currentTrialId != '' && trialId != currentTrialId;
          let _trial = await getStudy(trialId, null, getEmail());
          let study_json = _trial
          dataPreparationRes = study_json["status"] == "In Progress" || study_json["status"] == "Completed";
          retryTimes += 1
          if (dataPreparationRes && !isDiffTrial){
            // fetchList();
            message.success("Update Successful");
            localStorage.setItem('trial-id', trialId)
            localStorage.setItem('trial-detail', JSON.stringify(resp))
            props.fetchHistory({
              shouldFetch: true,
              historyData:[]
            })
          }
          await sleep(pollingIntervalMS);
          showDetail = localStorage.getItem('show-details')?localStorage.getItem('show-details').toUpperCase() == 'TRUE':false
          } while (showDetail && !isDiffTrial && !dataPreparationRes && retryTimes <= 20);
        if (!dataPreparationRes && retryTimes > 20){
          message.error('No response for over 6 minutes, please call assist.')
        }
      }else{
          message.error("Failed to update");
      }
    }
  };

  const handleCancel = () => {
    setStep(0)
    localStorage.setItem('steps', '0')
    setTrialAliasError("")
    setTrialTitleError("")
    setTherapeuticAreaError("")
    setIndicationError("")
    setDescriptionError("")
    setMoleculeNameError("")
    setEstimatedTotalError("") 
    setNumberOfArmsError("")
    setLengthOfTreatmentError("")
    // setVisible(false);
    setNewTrial(initialState);
    setIndicationList(sortIndication(indicationListAll))
    setSelectedMoaData([])
    setSelectedPatientSegmentData([])
    setResetTrialsCount(false);
    setNavigateToTeamsPage(true)
    setSoaCount(0);  
    resetTrial();
    props.fetchHistory({
        shouldFetch: true,
        historyData:[]
      })
    props.history.push("/trials");
  };

  const HandleTrialDetailUpdate = async(key, v) => {
    setNewTrial(v)
    props.createTrial(v)
    localStorage.setItem('newTrial', JSON.stringify(v))
    setUpdateDetail(true)
    setIndicationList(sortIndication(indicationListAll))
    newTrial["indication"] = []
    // clear all error message for required fields
    setTrialAliasError("")
    setTrialTitleError("")
    setTherapeuticAreaError("")
    setIndicationError("")
    setDescriptionError("")
    setMoleculeNameError("")
    setEstimatedTotalError("")
    setNumberOfArmsError("")
    setLengthOfTreatmentError("") 
    switch (key) {
      case "edit_details":
      setStep(0)
      localStorage.setItem('steps', '0')
      setEditDetailTitle("Edit Details")
        break;
      case "edit_similiarTrials":
      setStep(1)
      localStorage.setItem('steps', '1')
      setEditDetailTitle("Edit Similar Historical Trial")
        break;
      case "edit_teamMembers":
      setStep(2)
      localStorage.setItem('steps', '2')
      setEditDetailTitle("Edit Team Members")
      // fetch team member list
      const resp = await listMembers("")      
      if (resp) {
        let memberList = Object.values(resp)?Object.values(resp).map((item,index)=>{
          return item
        }):[]
        setTeamMember(memberList)
      }
        break;
      default:
      setStep(0)
      localStorage.setItem('steps', '0')
      setEditDetailTitle("Edit Details")
        break;
    }
  };

  const moaDataHandler = (moa, pSegment) => {
    setMoaList(moa)
    setPatientSegmentList(pSegment)
  }

  const handleCycleBasedInputReset = (key, e) => {
    setNewTrial({
      [key]: e,
    });
    props.createTrial({
      [key]: e,
    })
    localStorage.setItem('newTrial',  JSON.stringify(Object.assign(JSON.parse(localStorage.getItem('newTrial')),{
      [key]: e,
    })))
  }
  const handleNewTrialInputChange = (key, e) => {  
    if (key === "estimated_enrollment_count" || key === "number_of_arms" || key === "treatment_duration" || key == "treatment_duration_months" || key == "days_per_cycle") {
      setNewTrial({
        [key]: e,
      });
      props.createTrial({
        [key]: e,
      })
      localStorage.setItem('newTrial',  JSON.stringify(Object.assign(JSON.parse(localStorage.getItem('newTrial')),{
        [key]: e,
      })))

    } else {
      setNewTrial({
        [key]: e.target.value,
      });
      props.createTrial({
        [key]: e.target.value,
      })

      localStorage.setItem('newTrial',  JSON.stringify(Object.assign(JSON.parse(localStorage.getItem('newTrial')),{
        [key]: e.target.value,
      })))
      
    }
  };

  const resetMessageHandler = () => { 
    setTrialAliasError("")
    setTrialTitleError("")
    setTherapeuticAreaError("")
    setIndicationError("")
    setDescriptionError("")
    setMoleculeNameError("")
    setEstimatedTotalError("")
    setNumberOfArmsError("")
    setLengthOfTreatmentError("")
    setEstimatedDurationError("")
    setCycleBasesTrialError("")
    setDaysPerCycleError("")
  }

  const handleNewTrialSelectChange = (key, v) => {
    if(key == "therapeutic_area"){
        handleTherapeuticAreaChange(v, newTrial)
        resetIndication()
    }
    if(key == 'indication') {
      props.setPresets([])
    }
    setNewTrial({
      [key]: v,
    });
    props.createTrial({
      [key]: v,
    })

    localStorage.setItem('newTrial',  JSON.stringify(Object.assign(JSON.parse(localStorage.getItem('newTrial')),{
      [key]: v,
    })))

  };

  const handleTherapeuticAreaChange = (v, trialRef) => {
      let indications = indicationTherapeuticMap[v] !== undefined ? [indicationTherapeuticMap[v]] : []
      setIndicationList(sortIndication(indications))
      trialRef["indication"] = trialRef["indication"].filter(ind => indications.map(i => i.value).includes(ind))

  };

  const resetIndication = () => {
    setNewTrial({
      "indication": [],
    });
    props.createTrial({
      "indication": [],
    })

    localStorage.setItem('newTrial',  JSON.stringify(Object.assign(JSON.parse(localStorage.getItem('newTrial')),{
      "indication": [],
    })))
  }
  
  const soaSelectionHandler = (val) => {
    showSOAModal(false)
    setSoaCount(val) 
    setNavigateToTeamsPage(false)
  }

  const saveAsPreset = () => {
    if(props.newTrial.similarHistoricalTrials.length > 0) {
      setShowPresetPopup(true)
    }
  }

  const handlePresetsInputChange = (key, evt) => {
    const value = evt.target.value 
    setPresetData((prevState) => ({  
      ...prevState,  
      [key]: value
    }));  
  }

  const handlePresetContinue = async () => {
    setIsSavePreset(true)
    setPresetErrorMsg(null)
    if(presetsData?.preset_name?.length == 0) {
      setPresetErrorMsg("Preset name is required" )
      return
    }
    const payload = {
      ...presetsData,
      soa_study_count: parseInt(localStorage.getItem('SoaCount')),
      total_study_count: props.newTrial.similarHistoricalTrials.length,
      preset_value_list: props.newTrial.similarHistoricalTrials,
      user_mail_id : getEmail(),
      indication_id_list : props.newTrial?.indication,
    }
    const response = await saveTrialPresets(payload)
    if(response) {
      const { statusCode, state, preset_name } = response
      if(statusCode == 500 && state == 'DUPLICATE_PRESET_NAME') {
        setPresetErrorMsg("This preset name already exists, please enter a unique name!" )
        setIsSavePreset(false)
      } 
      else if( statusCode == 500 && state == 'DUPLICATE_PRESET_VALUES') {
        setIsSavePreset(false)
        setPresetErrorMsg(`Preset "${preset_name}" with  same set of trials already exist.`)
      } else if(statusCode == 200) {
        setIsSavePreset(false)
        await fetchPresets()
        setShowPresetPopup(false)
        setPresetErrorMsg(null)
        setPresetData(presets_init)
        filterTabChangeHandler(false)
        setSelectPresetOnSave(true)
      }  
    }
  }

  const saveResetHandler = (val) => {
    setSelectPresetOnSave(val)
  }

  const handlePresetCancel = () => {
    setShowPresetPopup(false)
    setPresetErrorMsg(null)
    setPresetData(presets_init)
  }

  useEffect(() => {
    fetchPresets()
  }, [props.newTrial?.indication])

  const fetchPresets =  async () => {
    const response = await getTrialPresets("getTrialPresets", "indication_id_list", props.newTrial?.indication)
    if(response) {
      let presetData = response['preset_list']?.sort((a, b) => {  
        const dateA = new Date(a?.created_dt?.replace(' ', 'T'));  
        const dateB = new Date(b?.created_dt?.replace(' ', 'T'));  
        return dateB?.getTime() - dateA?.getTime();
      });    
      props.setPresets(presetData)
    }
  }

  const filterTabChangeHandler = (val) => {
    setIsFilterTab(val)
  }

  return (
    <div className="create-new-trial-container">
      <div className="new-trial-wrapper">
        <div className="new-trial-content">
          <div className="trial-title">{updateDetail?editDetailTitle:"New trial"}</div>
          <div className="trial-content">
            {!updateDetail&&<div className="nav-bar">
              <Steps
                current={step} 
                progressDot={(dot, { status, index }) => (
                <span>
                  {dot}
                </span>
              )}>
                {timeline.map((t, idx) =>
                  <Step title={t} key={t}/>
                )}
              </Steps>
            </div>}
            <div className={`center-content ${step === 1 ? 'similar-table' : ''}`}>
              {step==0 && <>
                <div className="title">
                  <div className="text">Trial summary</div>
                </div>
                <TrialSummary 
                handleNewTrialInputChange={handleNewTrialInputChange} 
                handleNewTrialSelectChange={ handleNewTrialSelectChange} 
                newTrial={Object.keys(JSON.parse(localStorage.getItem('newTrial'))).length !== 0?JSON.parse(localStorage.getItem('newTrial')):newTrial} 
                indicationList={indicationList}
                therapeuticAreaList={therapeuticAreaList}
                handleValidation={handleValidation}
                trialAliasError={trialAliasError}
                trialTitleError={trialTitleError}
                therapeuticAreaError={therapeuticAreaError} 
                indicationError={indicationError} 
                studyPhaseList={studyPhaseList}
                studyTypeList={studyTypeList} 
                studyCountryList={studyCountryList} 
                descriptionError={descriptionError}
                moleculeNameError={moleculeNameError}
                updateDetail={updateDetail}
                indicationTherapeuticMap={indicationTherapeuticMap}
                estimatedTotalError={estimatedTotalError}
                numberOfArmsError={numberOfArmsError}
                lengthOfTreatMentError={lengthOfTreatMentError}
                estimatedDuration={estimatedDuration}
                cycleBasesTrial={cycleBasesTrial}
                daysPerCycle={daysPerCycle}
                handleCycleBasedInputReset={handleCycleBasedInputReset}
                resetErrorMessage={resetMessageHandler}
                />
              </>
              }
              {step === 1 && <>
                <SimilarHistoricalTrials
                selectedMoaData={selectedMoaData}
                patientSegmentData={patientSegmentData}
                loadMoaData={moaDataHandler}
                moaList={moaList}
                patientSegmentList={patientSegmentList}
                indicationList={ indicationListAll} handleNewTrialSelectChangeHistory={ handleNewTrialSelectChange}
                studyPhaseList={studyPhaseList} studyTypeList={studyTypeList} studyStatusList={studyStatusList} selectedSOA={soaSelectionHandler}
                resetTrials={resetTrialHandler} resetTrialsCount={resetTrialsCount} isUpdate={updateDetail}
                indicationTherapeuticMap={indicationTherapeuticMap}
                isSaveTrial={isSaveTrial}
                isCycleBased={props.newTrial.cycle_based_trial_flag}
                presetsData={presetsData}
                filterTabChange={filterTabChangeHandler}
                isFilterTab={isFilterTab}
                saveStatusReset={saveResetHandler}
                savedPreset={selectPresetOnSave}
                />
              </>}
              {step === 2 &&  
              <Spin spinning={drawerloading}
              indicator={<LoadingOutlined style={{ color: "#ca4a04" }}/>} >
                <div className="title">
                  <div className="text">Add team members</div>
                </div>
                <TeamMembers teamMember={teamMember} roles={rolesList}/> 
              </Spin>
              }
            </div>
          </div>
        </div> 
        <div className="new-trial-footer">
            <div className="left-action">
              <Button size="small" type="text" className="cancel-btn" onClick={handleCancel}>Cancel</Button>
              {!updateDetail && step > 0 && step <=(timeline.length-1)? <span className="go-prev-step" 
              onClick={()=>{
                setStep(step-1)
                localStorage.setItem('steps', (step - 1).toString())
              }}><LeftOutlined />{ timeline[step-1]}</span>:null}
            </div>
            {!updateDetail && (<div>
              {step === 1 && isFilterTab &&(<span 
                className={`create-preset-btn ${props.newTrial.similarHistoricalTrials?.length <= 0 ? 'preset-btn-disable' : 'preset-btn-enable'}`}
                onClick={saveAsPreset}>Save as preset</span>)}
              <Button  size="small" 
               type="primary"
               className="create-update-btn" 
               onClick={step>=(timeline.length-1)?handleOk:handleNextStep}
               disabled= {createTrialBtn}
                >
                {
                  // step>=(timeline.length-1)? "Create Trial":`Next Step: ${timeline[step+1]}`
                  step>=(timeline.length-1)? "Create":"Continue"
                }
              </Button>
            </div>)}
            {updateDetail&&
             ( 
              <div>
               {step === 1 && isFilterTab && (<span 
                className={`create-preset-btn ${props.newTrial.similarHistoricalTrials?.length <= 0 ? 'preset-btn-disable' : 'preset-btn-enable'}`}
                onClick={saveAsPreset}>Save as preset</span>)}
              <Button  size="small" type="primary" className="create-update-btn" onClick={handleDetailUpdate}>
                Update
              </Button>
            </div>  
            )
            }
        </div>
      </div>

     {soaModal && ( <Modal visible={soaModal} className="SimialarHistoryModal"  onOk={handleContinue} onCancel={handleChange}
        footer={[
          <Button 
            key="back"  
            onClick={handleChange} 
          >
            No, change
          </Button>,
          <Button 
            key="submit" 
            disabled={isSavePreset} 
            className="continue-btn"
            onClick={handleContinue} 
          >
            Yes, continue
          </Button>,
          ,
        ]}
        >
          <h1> Are you sure?</h1>
          <div>There are less than 10 trials in your similar historical trial list that have Schedule of Activities data.</div>
        </Modal>)}

        {showPresetPopup && ( 
          <Modal 
          visible={showPresetPopup}   
          title="Preset Information" 
          className="PresetModal"  
          onOk={handlePresetContinue} 
          onCancel={handlePresetCancel}
          centered
          footer={[
            <Button key="back"  onClick={handlePresetCancel} >
              Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={handlePresetContinue} >
              Save Preset
            </Button>,
            ,
          ]}
          >
         {presetErrorMsg && presetErrorMsg !== '' && (<span className="preset-error">{presetErrorMsg}</span>)}
         <br />
         <div className="trial-item">
          <label htmlFor="">Preset name  <span className="required">*</span> </label>
          <Input
            style={{ width: "100%", height: 30 }}
            onChange={(v) => handlePresetsInputChange("preset_name", v)}
            maxLength={100}
          />
          
          <br/>
          <span className="presets-name-error">{props.therapeuticAreaError}</span>
        </div>
        <div className="trial-item">
          <label htmlFor="">Description</label>
          <TextArea
            onChange={(v) => handlePresetsInputChange("description", v)}
            maxLength={500}  
          />
        <br/>
        <span className="presets-description-error">{props.therapeuticAreaError}</span>
        </div> 
        </Modal>)}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  createTrial: (val) => dispatch(createActions.createTrial(val)),
  fetchHistory:(val) => dispatch(historyActions.fetchHistory(val)),
  setPresets: (val) => dispatch(createActions.setPresets(val)),
});

const mapStateToProps = (state) => ({
  newTrial: state.trialReducer,
  historyTrial:state.historyReducer,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(NewTrial));
